import keyMirror from 'key-mirror';

export default keyMirror({
  CAREPLAN: null,
  PROFILE: null,
  PATIENT: null,
  PATIENTLIST: null,
  PATIENTPROGRESS: null,
  ALERT: null,
  USER: null,
  DELEGATE: null,
  PATIENTMESSAGE: null,
  REMINDER: null,
  GROUP: null,
  GROUP_ASSIGN: null,
  FOLLOWUP: null,
  REPORTS:null

});